export default "__VITE_ASSET__Bz1q7LzA__"